import type { StrictOmit } from '@enmon/commons';
import type { SerializedEstablishment } from '@enmon/commons/lib/enmon';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import { APP_DICTIONARY } from '../root';

type TranslatedEstablishmentKeys =
  | keyof StrictOmit<SerializedEstablishment, '_id' | '__v' | 'createdAt' | 'updatedAt' | 'avatarFile'>
  | 'defaultLocation'
  | 'certificates';

export const ESTABLISHMENT_FIELDS_TRANSLATED = defineMessages<TranslatedEstablishmentKeys>({
  // Common keys
  customer: {
    id: 'app.common.collections.customers',
  },

  // Translated keys
  name: APP_DICTIONARY.name,
  code: APP_DICTIONARY.code,
  floorArea: {
    id: 'app.common.establishment.fields.floorArea',
  },
  buildingVolume: {
    id: 'app.common.establishment.fields.buildingVolume',
  },
  tags: APP_DICTIONARY.tags,
  address: {
    id: 'app.common.establishment.fields.address',
  },
  parent: {
    id: 'app.common.establishment.fields.location',
  },
  businessHours: APP_DICTIONARY.businessHours,
  type: {
    id: 'app.common.establishment.fields.type',
  },

  // Additional related translations
  defaultLocation: {
    id: 'app.common.establishment.fields.defaultLocation',
  },
  certificates: {
    id: 'app.common.establishment.fields.certificates',
  },
});
